/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import { DOMModel, byAttrVal, byJsonAttrVal, byBooleanAttrVal } from '@adobe/react-webcomponent';
import CategoryFieldRoot from '../components/CategoryFieldRoot/CategoryFieldRoot';
import createCustomPickerElement from '../utils/createCustomPickerElement';

class CategoryFieldModel extends DOMModel {
    constructor() {
        super();
        this.addProperty('provideWebComponentApi', element => element._apiResolve);
    }

    @byAttrVal() name;
    @byAttrVal() value;
    @byAttrVal() placeholder;
    @byAttrVal('input-classes') inputClasses;
    @byAttrVal('aria-labelledby') labelledBy;
    @byBooleanAttrVal() disabled;
    @byJsonAttrVal() configs;
    // Possible values: id, slug, uid, urlPath, idAndUrlPath (deprecated), uidAndUrlPath (deprecated)
    @byAttrVal('selection-id') selectionId;
    @byBooleanAttrVal() multiple;
    @byBooleanAttrVal() invalid;
    @byAttrVal() target;
    @byAttrVal('target-type') targetType;
    @byBooleanAttrVal('show-link') showLink;
    @byAttrVal('current-value') currentValue;
    @byJsonAttrVal('picker-selected-data') pickerSelectedData;
}

(function () {
    const CategoryFieldElement = createCustomPickerElement(CategoryFieldRoot, CategoryFieldModel, 'element');

    const elemName = 'category-field';
    if (!window.customElements.get(elemName)) {
        window.customElements.define(elemName, CategoryFieldElement);
    }
})();
